import { trackEvent } from "@analytics";
import { Button } from "@biom3/react";
import { useMemo } from "react";
import { useWeeklyRewards } from "../WeeklyRewardsProvider";
import { RedeemKeyButton } from "./RedeemKeyButton";

export function RedeemAndClaim({
  onOpenRulesModal,
}: {
  onOpenRulesModal: () => void;
}) {
  const {
    eligibility,
    claimPrize,
    currentPeriod,
    hasFreeEntry,
    entryFee,
    hasTicketUpgrade,
    hasEnoughGems,
    redeemTicket,
    isEligibilityLoading,
  } = useWeeklyRewards();

  const hasWonIMX = eligibility?.rules.has_valuable_key;
  const shouldShowEligibilityCheck =
    currentPeriod === "CLAIM" && hasWonIMX && !eligibility?.is_eligible;
  const canUnlockReward =
    currentPeriod === "CLAIM" &&
    (!hasWonIMX || (hasWonIMX && eligibility?.is_eligible));

  const buttonSx = {
    width: { large: "312px", default: "auto" },
  };

  const isLoading = useMemo(
    () =>
      eligibility === undefined ||
      currentPeriod === undefined ||
      isEligibilityLoading,
    [eligibility, currentPeriod, isEligibilityLoading],
  );

  const handleClaim = async () => {
    try {
      trackEvent({
        component: "Button",
        action: "Pressed",
        extras: {
          control: "ClaimReward",
          section: "RewardsRedemption",
          userJourney: "Rewards",
        },
      });

      await claimPrize();
    } catch (error) {
      console.error("Failed to unlock prize", error);
    }
  };

  return (
    <>
      {isLoading ? (
        <Button size="large" disabled sx={buttonSx}>
          <Button.Icon icon="Loading" />
        </Button>
      ) : canUnlockReward ? (
        <Button
          disabled={currentPeriod !== "CLAIM"}
          size="large"
          onClick={handleClaim}
          sx={buttonSx}
        >
          Unlock Reward
        </Button>
      ) : shouldShowEligibilityCheck ? (
        <Button sx={buttonSx} disabled={true} size="large" variant="tertiary">
          Unlock After Completion
        </Button>
      ) : currentPeriod === "REDEEM" ? (
        <RedeemKeyButton
          onOpenRulesModal={onOpenRulesModal}
          shouldDirectlyRedeem={false}
          onRedeemTicket={redeemTicket}
          entryFee={entryFee}
          hasFreeEntry={hasFreeEntry}
          hasTicketUpgrade={hasTicketUpgrade}
          hasEnoughGems={hasEnoughGems}
        />
      ) : (
        <Button sx={buttonSx} size="large" variant="tertiary" disabled>
          Coming soon
        </Button>
      )}
    </>
  );
}
